/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useMemo } from "react";
import { format } from "date-fns";
import moment from "moment";
import { Link } from "react-router-dom";
import { TableCell } from "../../../components/DataTable";

export const WORK_ORDER_COLUMNS = removeListOrder => {
  const columns = [
    {
      Header: "Work Order",
      accessor: "WorkOrder",
      Cell: ({ row, cell }) => (
        <TableCell.Link
          to={`/fleet/work-orders/${row.original.RecId}/main-information`}
          value={cell.value}
        />
      )
    },
    {
      Header: "Status",
      accessor: "StatusCodeDesc",
      id: "Status",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "List Order",
      accessor: "StatusListOrder",
      id: "StatusListOrder"
    },
    {
      Header: "Scheduled Date",
      accessor: "WODate",
      Cell: ({ cell }) =>
        cell.value
          ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
              "MM/DD/YYYY"
            )
          : null
    },
    {
      Header: "Completed Date",
      accessor: "CompletedDate",
      Cell: ({ cell }) =>
        cell.value
          ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
              "MM/DD/YYYY"
            )
          : null
    },
    {
      Header: "Mechanic",
      accessor: "MechanicName",
      id: "MechanicName"
    },
    {
      Header: "Vehicle Number",
      accessor: "VehicleNumber",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Vehicle Description",
      accessor: "VehicleDesc",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Type",
      accessor: "WOType",
      id: "WOType",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Item Category",
      accessor: "ItemCatDesc",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Item Code",
      accessor: "ItemCatgCd",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Odometer",
      accessor: "Odometer",
      id: "Odometer",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Approval Date",
      accessor: "ApprovalDt",
      id: "ApprovalDt",
      Cell: ({ cell }) =>
        cell.value ? format(new Date(cell.value), "MM/dd/yyyy HH:mm") : null
    },
    {
      Header: "Approved By",
      accessor: "ApprovalByName",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Posted Date",
      accessor: "PostedDt",
      id: "PostedDt",
      Cell: ({ cell }) =>
        cell.value ? format(new Date(cell.value), "MM/dd/yyyy HH:mm") : null
    },
    {
      Header: "Posted By",
      accessor: "PostedByName",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Location Name",
      accessor: "LocationName",
      id: "LocationName",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "CreatedBy",
      accessor: "CreatedBy",
      id: "CreatedBy"
    },
    {
      Header: "Created Date",
      accessor: "CreatedDateTime",
      Cell: ({ cell }) =>
        cell.value ? format(new Date(cell.value), "MM/dd/yyyy HH:mm") : null
    }
  ];
  if (removeListOrder) {
    columns.splice(2, 1);
  }
  return columns;
};

export const WORK_ORDER_LABOR_COLUMNS = [
  {
    Header: "WO #",
    id: "WONumber",
    accessor: "WorkOrder",
    Cell: ({ cell }) => (
      <Link to={`/fleet/work-orders/${cell.value.RecId}/main-information`}>
        #{cell.value.WorkOrder}&nbsp;
      </Link>
    )
  },
  {
    Header: "Completed Date",
    id: "CompletedDate",
    accessor: "WorkOrder.CompletedDate",
    Cell: ({ cell }) =>
      cell.value
        ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
            "MM/DD/YYYY"
          )
        : null
  },
  {
    Header: "Mechanic",
    accessor: "WorkOrder.MechanicName",
    id: "MechanicName"
  },
  {
    Header: "Item Category",
    accessor: "ItemCategory.Description",
    Cell: ({ cell }) => (cell.value ? cell.value : "-")
  },

  {
    Header: "Description",
    accessor: "Description",
    Cell: ({ cell }) => (cell.value ? cell.value : "-")
  },
  {
    Header: "HRS",
    accessor: "HoursWorked",
    Cell: ({ cell }) => <TableCell.Number value={JSON.stringify(cell.value)} />
  },
  {
    Header: "WO Status",
    accessor: "WOStatus.CodeDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "-")
  },
  {
    Header: "Note",
    accessor: "LineNote",
    Cell: ({ cell }) => (cell.value ? cell.value : "-")
  },
  {
    Header: "#",
    accessor: "LineNo",
    Cell: ({ cell }) => (cell.value ? cell.value : "-")
  }
];

export const WORK_ORDER_PARTS_COLUMNS = (Auth = false) => {
  const columns = [
    {
      Header: "WO #",
      id: "WONumber",
      accessor: "WorkOrder",
      Cell: ({ cell }) => (
        <Link to={`/fleet/work-orders/${cell.value.RecId}/main-information`}>
          #{cell.value.WorkOrder}&nbsp;
        </Link>
      )
    },
    {
      Header: "Completed Date",
      id: "CompletedDate",
      accessor: "WorkOrder.CompletedDate",
      Cell: ({ cell }) =>
        cell.value
          ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
              "MM/DD/YYYY"
            )
          : null
    },
    {
      Header: "Mechanic",
      accessor: "WorkOrder.MechanicName",
      id: "MechanicName"
    },
    {
      Header: "Item Category",
      accessor: "ItemCategory.Description",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Item #",
      accessor: "Item.ItemNo",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Item Description",
      accessor: "Item.Description",
      Cell: ({ cell }) => (cell.value ? cell.value : "-")
    },
    {
      Header: "Quantity",
      accessor: "Quantity",
      id: "Quantity",
      Cell: ({ cell }) => (
        <TableCell.Number value={JSON.stringify(cell.value)} />
      )
    }
  ];
  if (Auth) {
    columns.push({
      Header: "Cost",
      accessor: "Cost",
      Cell: ({ cell }) => (
        <TableCell.Currency value={JSON.stringify(cell.value)} />
      )
    });
  }
  return [
    ...columns,
    ...[
      {
        Header: "Odometer",
        accessor: "WorkOrder.Odometer",
        Cell: ({ cell }) => (
          <TableCell.Number value={JSON.stringify(cell.value)} />
        )
      },
      {
        Header: "WO Status",
        accessor: "WOStatus.CodeDescription",
        Cell: ({ cell }) => (cell.value ? cell.value : "-")
      },
      {
        Header: "Note",
        accessor: "LineNote",
        Cell: ({ cell }) => (cell.value ? cell.value : "-")
      },
      {
        Header: "#",
        accessor: "LineNo",
        Cell: ({ cell }) => (cell.value ? cell.value : "-")
      }
    ]
  ];
};

export const generateApprovedWorkOrderColumns = ({
  onSelectAll,
  onSelect,
  selected
}) => [
  {
    Header: ({ data }) => {
      const allSelected = useMemo(
        () =>
          selected.length &&
          data.every(wo => selected.some(s => s === wo.RecId)),
        [data]
      );
      const someSelected = useMemo(
        () =>
          selected.length &&
          data.some(wo => selected.some(s => s === wo.RecId)),
        [data]
      );
      return (
        <TableCell.Checkbox
          checked={!!allSelected}
          indeterminate={!allSelected && !!someSelected}
          onChange={() =>
            onSelectAll(
              allSelected,
              data.map(wo => wo.RecId)
            )
          }
        />
      );
    },
    id: "RecId",
    defaultCanSort: false,
    disableSortBy: true,
    accessor: "RecId",
    Cell: ({ row }) => (
      <TableCell.Checkbox
        checked={selected.includes(row.original.RecId)}
        onChange={() => onSelect(row.original)}
        onClick={e => e.stopPropagation()}
      />
    )
  },
  ...WORK_ORDER_COLUMNS(true)
];
